const React = require('react');
const { useCallback, useState } = require('react');
const useGlobalSearchShortcut = require('./useGlobalSearchShortcut');
const useGlobalSearchAccess = require('./useGlobalSearchAccess');
const useRecentFieldsTracker = require('./useRecentFieldsTracker');
const GlobalSearchModal = require('./GlobalSearchModal');

require('figmaCSS');
require('./GlobalSearch.scss');

/**
 * Cmd + K / Ctrl + K entity search. Mounted once, app-wide.
 *
 * Owns nothing but the open flag — the index, the query and the keyboard
 * handling all live in GlobalSearchModal, which is unmounted while closed so
 * no work happens until the user asks for it. Users outside the rollout gate
 * (see useGlobalSearchAccess) get no listener and no modal.
 *
 * The one thing that cannot live in the modal is the recently-visited-fields
 * trail: it has to be collected while the modal is closed, which is when the
 * visiting happens. So it is tracked here, where the component is always
 * mounted.
 */
const GlobalSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const hasAccess = useGlobalSearchAccess();

  // 'Global Search Opened' is tracked by the modal on mount, where the index
  // it reports on is available.
  const openSearch = useCallback(() => setIsOpen(true), []);

  const closeSearch = useCallback(() => setIsOpen(false), []);

  useGlobalSearchShortcut(openSearch, hasAccess);
  useRecentFieldsTracker(hasAccess);

  if (!hasAccess || !isOpen) {
    return null;
  }
  return <GlobalSearchModal onClose={closeSearch} />;
};

module.exports = GlobalSearch;
